export default "__VITE_ASSET__DzZUtnFE__"